import React from "react";
import { MessagesSquare, CalendarCheck, Inbox, ShieldCheck, Moon, Compass } from "lucide-react";

const FEATURES = [
  {
    icon: MessagesSquare,
    title: "Answers Questions Instantly",
    body: "Pricing, availability, services, hours — your agent knows your business and responds immediately. No hold music. No \"we'll get back to you.\"",
  },
  {
    icon: CalendarCheck,
    title: "Books Appointments & Calls",
    body: "Integrates with Calendly to book real appointments. The agent doesn't just wave customers goodbye — it schedules the next step before they leave.",
  },
  {
    icon: Inbox,
    title: "Captures Lead Information",
    body: "Name, email, phone, what they need — the agent collects it all and organizes it so you wake up to a full pipeline, not silence.",
  },
  {
    icon: ShieldCheck,
    title: "Handles Objections",
    body: "Trained on your most common customer doubts. \"Is this worth it?\" \"How does this work?\" \"Can I trust you?\" — your agent closes the gap before it becomes a lost sale.",
  },
  {
    icon: Moon,
    title: "Works While You Sleep",
    body: "3 AM inquiry? Sunday night question? Holiday weekend lead? Covered. Your agent never clocks out. It's the employee that actually works 24/7.",
  },
  {
    icon: Compass,
    title: "Guides the Buying Journey",
    body: "Not every customer knows what they need. Your agent walks them through it — like a great salesperson at the front desk, not a confusing dropdown menu.",
  },
];

export default function Features() {
  return (
    <section id="features" data-testid="features-section" className="bg-[#0A0F1E] fs-section">
      <div className="fs-container">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#C9A84C]" />
            <span className="fs-tag">What Your Agent Does</span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase tracking-[0.03em] leading-[0.95] text-white">
            Every Feature Your<br />
            Business Actually Needs.
          </h2>
          <p className="mt-6 text-lg text-white/65 max-w-2xl leading-relaxed">
            Not AI jargon. Real things that happen when customers visit your website.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {FEATURES.map((f, i) => (
            <article key={i} data-testid={`feature-card-${i}`} className="fs-card">
              <div className="h-11 w-11 rounded-md bg-[#C9A84C] text-[#0A0F1E] flex items-center justify-center">
                <f.icon size={20} strokeWidth={1.8} />
              </div>
              <h3 className="mt-6 font-display text-2xl tracking-[0.04em] uppercase text-white">
                {f.title}
              </h3>
              <p className="mt-3 text-sm text-white/65 leading-relaxed">{f.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
